import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import { $url } from '../utils/request';
import { saveAs } from 'file-saver';
import { baseURL } from '@/config';
import { useUserStore } from '~/src/store/modules/user';
export async function getImageUrl(fileName) {
  const fileInfo = await axios.get(`${$url}?imgName=${fileName}`);
  return fileInfo['url'];
}
export async function imageUrl(fileName) {
  const url = await axios.get(`/api/media/url/${fileName}`);
  return url;
}
export async function singalfileList(fileName) {
  if (!fileName) {
    return [];
  }
  const url = await axios.get(`/api/media/url/${fileName}`);
  return [{
    name: fileName,
    url: url,
    response: {
      url: url,
      name: fileName
    }
  }];
}
export function getEnum(enumType) {
  return axios.get(`/api/identity/enum/${enumType}`);
}
export function getDictionary(keyType) {
  return axios.get(`/api/cloud/data-dic/dic-items?keyType=${keyType}`);
}
export async function getEnumNameValue(enumType) {
  try {
    const res = await axios.get(`/api/identity/enum/${enumType}`);
    return res.map(item => ({
      name: item.description ?? item.name,
      value: item.value
    }));
  } catch (e) {
    console.error('获取枚举失败:', e);
    return [];
  }
}
export function getCloudEnum(enumType) {
  return axios.get(`/api/cloud/enum/${enumType}`);
}
export async function getCloudEnumNameValue(enumType) {
  try {
    const res = await axios.get(`/api/cloud/enum/${enumType}`);
    return res.map(item => ({
      name: item.description ?? item.name,
      value: item.value
    }));
  } catch (e) {
    console.error('获取枚举失败:', e);
    return [];
  }
}
export async function getBaseSetting(infoCode) {
  try {
    const res = await axios.get(`/api/cloud/base-info/base-setting?infoCode=${infoCode}`);
    return res.keyValue;
  } catch (e) {
    console.error('获取基础设置失败:', e);
    return [];
  }
}
export async function getOrganizationUnit() {
  try {
    const res = await axios.get(`/api/cloud/flow-info?maxResultCount=999`);
    return res.items;
  } catch (e) {
    console.error('获取业务类型失败:', e);
    return [];
  }
}
export async function getFlowInfo() {
  try {
    const res = await axios.get(`/api/cloud/flow-info?maxResultCount=999`);
    return res.items;
  } catch (e) {
    console.error('获取业务类型失败:', e);
    return [];
  }
}
/**
 * 物料数据
 */
export async function getMaterials() {
  return await axios.get(`/api/cloud/material/select-list`);
}
export async function getTableFieldMust(fieldType) {
  const res = await axios.get(`/api/cloud/table-field-must/field-must-list?fieldType=${fieldType}`);
  return res;
}
export function getLabelByList(url, count = 9999) {
  return axios.get(`${url}?maxResultCount=${count}`);
}
export function getCustomizeParameter(params) {
  return axios.get(`/api/cloud/customize-parameter?isDispatchOrder=${!!params}`);
}
export function getBaseinfoSpecial() {
  return axios.get(`/api/cloud/base-info/special`);
}
/**
 * 下载文件以流的形式
 * @param params
 * @param callback
 * @returns
 */
export async function downloadFile(url, filename, callback) {
  try {
    const response = await axios.create({
      baseURL: baseURL
    }).post(url, {}, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${useUserStore().token}`
      }
    });
    if (response.status !== 200 || response.data.size <= 0) {
      return null;
    }
    saveAs(response.data, decodeURI(filename));
    callback?.();
    return true;
  } catch (err) {
    console.error(err);
    return null;
  }
}
let httpUrl = 'api/file/download';
export async function doExport(params, callback) {
  try {
    // 直接用 axios 创建新实例，跳过拦截器
    const response = await axios.create({
      baseURL: baseURL
    }).get(httpUrl, {
      params,
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${useUserStore().token}`
      }
    });
    if (response.status !== 200 || response.data.size <= 0) {
      return null;
    }
    const filename = params.fileName;
    saveAs(response.data, decodeURI(filename));
    callback?.();
    return true;
  } catch (err) {
    console.error(err);
    return null;
  }
}
export function matchField(fieldList, fieldName) {
  return fieldList.find(f => f.fieldName.toLowerCase() === fieldName.toLowerCase());
}
export function matchFieldv2(fieldList, fieldMap, fieldName) {
  const backendFieldName = Object.keys(fieldMap).find(key => fieldMap[key].prop.toLowerCase() === fieldName.toLowerCase());
  const targetFieldName = backendFieldName || fieldName;
  return fieldList.find(f => f.fieldName.toLowerCase() === targetFieldName.toLowerCase());
}